// extracted by css-extract-rspack-plugin
export default {"root":"ProgressStyles-module__root___Z8pt7"};